import { render, staticRenderFns } from "./TipsModel.vue?vue&type=template&id=4a766bae&scoped=true"
import script from "./TipsModel.vue?vue&type=script&lang=js"
export * from "./TipsModel.vue?vue&type=script&lang=js"
import style0 from "./TipsModel.vue?vue&type=style&index=0&id=4a766bae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a766bae",
  null
  
)

export default component.exports